import {FlowController} from "./FlowController";

export class IdentityFlowController extends FlowController {
    actionButtonDefaultAnid = "identity-button";
    logInFooterDefaultAnid = "identity-login-footer";
}
